export default __webpack_public_path__ + "static/bread_square-c4dfc06db4dd4099572d70b1b7ee1b42.jpg";